import { Switch, Text } from '@loadsmart/loadsmart-ui'
import { Avatar, Box, Card, CardContent, CardHeader, Grid, Stack, Typography } from '@mui/material'
import mapping from 'atoms/Icon/mapping'
import { InstallationDetail } from 'common/types/kraken-core/Installation'
import { IntegrationModule } from 'common/types/kraken-core/IntegrationModule'

export interface InstallationSummaryProps {
  installation: InstallationDetail
  integrationModule: IntegrationModule
}

function InstallationSummary({ installation, integrationModule }: InstallationSummaryProps) {
  return (
    <Stack spacing={1}>
      <Grid container justifyContent="space-between" alignItems="start" spacing={1}>
        <Grid item md={5}>
          <Box flexDirection={'row'} display="flex" alignItems="center">
            <Avatar
              sizes="large"
              sx={{
                backgroundColor: 'secondary.main',
              }}
            >
              {mapping['IntegrationModule']}
            </Avatar>
            <Stack spacing={1} pl={2}>
              <Text variant="caption-bold" color="color-neutral">
                Integraiton Module
              </Text>
              <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                {integrationModule?.name}
              </Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item md={3}>
          <Stack>
            <Text variant="caption-bold" color="color-neutral">
              Created at
            </Text>
            <Text variant="heading-sm-bold">
              {new Date(installation.created_at).toLocaleString()}
            </Text>
          </Stack>
        </Grid>
        <Grid item md={3}>
          <Stack>
            <Text variant="caption-bold" color="color-neutral">
              Updated at
            </Text>
            <Text variant="heading-sm-bold">
              {new Date(installation.updated_at).toLocaleString()}
            </Text>
          </Stack>
        </Grid>
        <Grid item md={1} justifyItems={'end'}>
          <Box>
            <Stack>
              <Text variant="caption-bold" color="color-neutral">
                Active
              </Text>
              <Switch id="is_active" name="is_active" active={installation.is_active} disabled />
            </Stack>
          </Box>
        </Grid>
      </Grid>

      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardHeader title="Party" />
              <CardContent>
                <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                  {installation.party.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardHeader title="Counterparty" />
              <CardContent>
                <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                  {installation.counterparty.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  )
}

export default InstallationSummary
